export enum AppointmentPrioritiesTypes {
  GET_ALL = '@appointmentPriorities/GET_ALL',
  GET_ALL_SUCCESS = '@appointmentPriorities/GET_ALL_SUCCESS',
  GET_ALL_FAILED = '@appointmentPriorities/GET_ALL_FAILED',
}
